import { createI18n } from 'vue-i18n'

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      // ここでファイル名「～_locale」で取得するので、jsonファイルを追加する際は注意
      const locale = matched[1].split('_')[1]
      if (!messages[locale]) {
        messages[locale] = locales(key)
      } else {
        messages[locale] = Object.assign(messages[locale], locales(key))
      }
    }
  })
  return messages
}

export default createI18n({
  legacy: false, 

  locale: process.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE,
  messages: loadLocaleMessages()
})